// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PieCard_wrapper__2d6kf"};